module.exports = __webpack_public_path__ + "img/fruit-brambles-350x184.508a1dbb.jpg";